import React from 'react';
import Badge from '../Badge/Badge';

interface ReactivatedBadgeProps {
  visible?: boolean | null;
  className?: string;
}

const ReactivatedBadge: React.FC<ReactivatedBadgeProps> = ({ visible, className }) => {
  if (!visible) {
    return null;
  }

  return (
    <Badge variant="primary" className={className}>
      Reativada
    </Badge>
  );
};

export default ReactivatedBadge;
